const trimTrailingSlash = (value) => String(value || '').replace(/\/+$/, '');

const DOCS_HOME_BY_LOCALE = {
  ru: '/opisanie/o-platforme',
  en: '/eng/description/platform'
};

const normalizeDocsLocale = (value) =>
  String(value || '').toLowerCase().startsWith('en') ? 'en' : 'ru';

const stripKnownDocsHome = (value) =>
  String(value || '')
    .replace(/\/opisanie\/quickstart(?=\/?$|[?#])/i, '')
    .replace(/\/opisanie\/o-platforme(?=\/?$|[?#])/i, '')
    .replace(/\/eng\/description\/quickstart(?=\/?$|[?#])/i, '')
    .replace(/\/eng\/description\/platform(?=\/?$|[?#])/i, '');

const getStoredLocale = () => {
  if (typeof window === 'undefined') return 'ru';
  const stored = window.localStorage?.getItem('i18nextLng');
  return normalizeDocsLocale(stored || window.navigator?.language || 'ru');
};

export const getDocsUrl = (localeInput) => {
  const locale = normalizeDocsLocale(localeInput || getStoredLocale());
  const docsHome = DOCS_HOME_BY_LOCALE[locale];
  const envUrl = String(process.env.REACT_APP_DOCS_URL || '').trim();

  if (envUrl) {
    return `${trimTrailingSlash(stripKnownDocsHome(envUrl))}${docsHome}`;
  }

  if (process.env.NODE_ENV === 'development') {
    return `http://localhost:4173${docsHome}`;
  }

  return `/guide${docsHome}`;
};

export const getDocsUrlForRedirect = (localeInput) => {
  const url = getDocsUrl(localeInput);
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  return `${trimTrailingSlash(window.location.origin)}${url.startsWith('/') ? url : `/${url}`}`;
};
